import _ from 'lodash';
import type React from 'react';

interface SquareTagContainerProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  position?: 'left' | 'right';
}

const SquareTagContainer: React.FC<SquareTagContainerProps> = ({ children, style, position }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      ...style,
      ...(!_.isNil(position) && {
        position: 'absolute',
        [position]: 0,
        marginLeft: '0.25em',
        marginRight: '0.25em',
      }),
    }}
  >
    {children}
  </div>
);

export default SquareTagContainer;
